import { Subject } from "rxjs";

export interface ClosableWorkspace {
  showCloseButton: boolean;
  close?: Subject<void>;
}

export function isClosable(workspace: ClosableWorkspace): workspace is ClosableWorkspace {
  return workspace.showCloseButton !== undefined;
}